// Outgoing calls (Stage 4.8b, guide §6.12): the server's words for where a business stands and why a call may not go, mirrored
// here so every one is worded on screen — scripts/check-outbound.cjs holds these lists to server/ai/outbound.js and to the five
// locale files.

export const ACCESS_STATUSES = ["none", "requested", "approved", "declined", "revoked"];

export const CHECK_REASONS = [
  "not_requested", "awaiting_approval", "declined", "revoked", "bad_number",
  "local_not_approved", "local_off", "international_not_approved", "country_not_allowed", "international_off",
  "account_inactive", "account_restricted", "subscription_restricted",
  "no_subscription", "credit_low", "credit_paused", "credit_exhausted", "no_route", "not_enough_credit",
];

export const DIAL_FORMATS = ["plus", "intl", "00", "national"];

// A country's name in the screen's language (the browser's own list); the code alone where the browser has none.
const namers = new Map();
export function countryName(code, lang) {
  if (!code) return "";
  try {
    if (!namers.has(lang)) namers.set(lang, new Intl.DisplayNames([lang || "en"], { type: "region" }));
    return namers.get(lang).of(code) || code;
  } catch {
    return code;
  }
}

// Tokens a minute, rounded the way a person reads a price.
export const perMinute = (n) => (Number.isFinite(Number(n)) ? Math.round(Number(n)).toLocaleString() : "—");
